import React, {Component} from 'react';

class ListPaymentByUserComponent extends Component {

    loadStatus = () => {
        if ( this.props.payment.status === 'Active' ) {
            return (
                <span className="text-success">
                    Đã thanh toán
                </span>
            )
        }
        else if ( this.props.payment.status === 'Waiting' ) {
            return (
                <span className="text-info">
                    Thanh toán chờ
                </span>
            )
        }
        else if ( this.props.payment.status === 'Pending' ) {
            return (
                <span className="text-danger">
                    Chưa thanh toán
                </span>
            )
        }
        else if ( this.props.payment.status === 'Cancel' ) {
            return (
                <span className="text-danger">
                    Hủy
                </span>
            )
        }

    }

    render() {
        return (
            <tr>
                <td>{ this.props.payment.ma_gd }</td>
                <td>{ this.props.payment.text_type_payment }</td>
                <td>{ this.props.payment.text_total }</td>
                <td>{ this.props.payment.text_create_date }</td>
                <td>{ this.props.payment.text_payment_date }</td>
                <td>
                    {
                        this.props.payment.status !== 'Pending' ? (
                            <>
                                {this.props.payment.text_before_credit}
                            </>
                        ) : (
                            <></>
                        )
                    }
                </td>
                <td>
                    {
                        this.props.payment.status !== 'Pending' ? (
                            <>
                                {this.props.payment.text_after_credit}
                            </>
                        ) : (
                            <></>
                        )
                    }
                </td>
                <td>{ this.loadStatus() }</td>
            </tr>
        );
    }
}

export default ListPaymentByUserComponent;